import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function winnerAnouncementModel() {
    const createCampaign = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Create_WA_Campaign",
        method: "POST",
        xRequest: "",
        payload: {
            Name_TH: "",
            Name_EN: "",
            Valid_Form: null,
            Valid_Through: null,
            Status: null,
        },
    });

    const fetchCampaignList = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/List_WA_Campaign",
        method: "POST",
        xRequest: "",
        payload: {
            Page: 1,
            Limit: 10,
            Filters: [],
            Ordering: []
        },
    });

    const fetchCampaignDetail = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Detail_WA_Campaign",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null
        },
    });

    const editCampaign = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Update_WA_Campaign",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,
            Name_TH: "",
            Name_EN: "",
            Valid_Form: null,
            Valid_Through: null,
            Status: null,
        },
    });

    const deleteCampaign = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Delete_WA_Campaign",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,

        },
    });

    const setCampaignStatus = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Change_Status_Campaign",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,
            Status: null
        },
    });

    // round

    const setRoundStatus = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Change_Status_Round",
        method: "POST",
        xRequest: "",
        payload: {
            RoundId: null,
            Status: null
        },
    });

    const createRound = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Create_WA_Round",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,
        },
    });

    const editRound = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Update_WA_Round",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,
            RoundId: null,
            Round_Name_TH: "",
            Round_Name_EN: "",
            Valid_Form: null,
            Valid_Through: null,
            Status: null,
        },
    });

    const deleteRound = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Delete_WA_Round",
        method: "POST",
        xRequest: "",
        payload: {
            RoundId: null,
        },
    });

    const fetchRoundDetail = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Detail_WA_Round",
        method: "POST",
        xRequest: "",
        payload: {
            RoundId: null
        },
    });

    const fetchRoundList = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/List_WA_Round",
        method: "POST",
        xRequest: "",
        payload: {
            CampaignId: null,
            Page: 1,
            Limit: 10,
            Filters: [],
            Ordering: []
        },
    });



    // reward
    const createReward = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Create_WA_Reward",
        method: "POST",
        xRequest: "",
        payload: {
            RoundId: null,
        },
    });


    const editReward = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Update_WA_Reward",
        method: "POST",
        xRequest: "",
        payload: {
            RoundId: null,
            Rewards: {
                RewardId: null,
                Title: "",
                Reward_Name: "",
                Image: null,
                Image_URL: null,
                Reward_Value: null,
                Status: null,
                IsDisplay_Winner: null,
            }

        },
    });

    const deleteReward = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Delete_WA_Reward",
        method: "POST",
        xRequest: "",
        payload: {
            RewardId: null,
        },
    });

    const fetchDetailReward = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Detail_WA_Reward",
        method: "POST",
        xRequest: "",
        payload: {
            RewardId: null,
        },
    });

    const reorderReward = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Reorder_WA_Reward",
        method: "POST",
        xRequest: "",
        payload: {
            RewardId: null,
            From: null,
            To: null
        },
    });


    // winner

    const createWinner = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Create_WA_Winner",
        method: "POST",
        xRequest: "",
        payload: {
            RewardId: null,
            First_Name: "",
            Last_Name: "",
            Moblie_No: null,
            Address: "",
            UploadFile: null
        },
    });

    const deleteWinner = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Delete_WA_Winner",
        method: "POST",
        xRequest: "",
        payload: {
            RewardId: null,
            WinnerId: []
        },
    });

    const reorderWinner = reactive({
        api: apiEndpoint.bcrm_platform + "/WinnerAnnouncement/Reorder_WA_Winner",
        method: "POST",
        xRequest: "",
        payload: {
            WinnerId: null,
            From: null,
            To: null
        },
    });

    return {
        createCampaign,
        fetchCampaignList,
        fetchCampaignDetail,
        editCampaign,
        deleteCampaign,
        setCampaignStatus,
        setRoundStatus,
        createRound,
        editRound,
        deleteRound,
        fetchRoundDetail,
        fetchRoundList,
        createReward,
        editReward,
        deleteReward,
        fetchDetailReward,
        createWinner,
        deleteWinner,
        reorderReward,
        reorderWinner
    };
}